package com.exura.features.localization.domain.model

abstract class LangSet<T> {
    abstract fun getSet(language: Language): T
}

class BasicLangSet<T>(
    private val map: Map<Language, T>
) : LangSet<T>() {
    init {
        val requiredLanguages = Language.entries.toSet()
        require(map.keys == requiredLanguages) {
            "BasicLangSet must provide translations for all supported languages: $requiredLanguages. Missing: ${requiredLanguages - map.keys}"
        }
    }

    override fun getSet(language: Language): T = map[language]!!
}
